import { render, staticRenderFns } from "./EdgeManagement.vue?vue&type=template&id=d352ea98&scoped=true"
import script from "./EdgeManagement.vue?vue&type=script&lang=js"
export * from "./EdgeManagement.vue?vue&type=script&lang=js"
import style0 from "./EdgeManagement.vue?vue&type=style&index=0&id=d352ea98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d352ea98",
  null
  
)

export default component.exports